import { Component, OnInit } from '@angular/core';
import { StudentAccount } from '@df/interfaces';
import { Subject } from 'rxjs';
import { ActivatedRoute, Params } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { AccountService } from '@app/teacher/services/account.service';

@Component({
    selector: 'app-students-list',
    templateUrl: './students-list.component.html',
    styleUrls: ['./students-list.component.scss']
})
export class StudentsListComponent implements OnInit {
    cameFromLesson = false;
    selectedStudent: StudentAccount;
    studentAccounts: StudentAccount[] = [];
    sortedStudents: Array<StudentAccount> = [];
    lessonData: { subject: number; lesson: number };

    private destroy$ = new Subject<boolean>();

    constructor(private route: ActivatedRoute, private accountService: AccountService) {}

    public ngOnInit(): void {
        this.accountService.studentsUpdated.pipe(takeUntil(this.destroy$)).subscribe((students: StudentAccount[]) => {
            this.studentAccounts = students;
            this.selectStudentByParam();
            this.sortingStudents();
        });
        this.accountService.studentUpdated.pipe(takeUntil(this.destroy$)).subscribe((index: number) => {
            this.selectStudent(index);
        });
    }

    private selectStudentByParam() {
        /*
         * Этот метод помогает плавному переходу со страницы проведения на страницу банка выбранного ученика
         * */
        this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params: Params) => {
            if (params) {
                const index = +params['student'] - 1;
                if (index >= 0 && index < this.studentAccounts.length) {
                    this.lessonData = {
                        lesson: +params['lesson'],
                        subject: +params['subject']
                    };
                    this.cameFromLesson = true;
                    this.selectStudent(index);
                }
            }
        });
    }

    selectStudent(choosedStudent): void {
        this.accountService
            .getStudentAccount(choosedStudent.student)
            .subscribe((updatedStudentAccount: StudentAccount) => {
                this.selectedStudent = updatedStudentAccount;
                this.updateSelectedStudent();
            });
    }

    public deselectStudent() {
        this.selectedStudent = null;
        this.updateSelectedStudent();
    }

    private updateSelectedStudent(): void {
        this.accountService.studentSelected.next(this.selectedStudent);
    }

    sortingStudents() {
        this.sortedStudents = this.studentAccounts.sort((a, b) => {
            return a.student.surname.localeCompare(b.student.surname);
        });
    }
}
